// @ts-nocheck
import {
  Badge,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Box,
  Icon,
  Text,
} from '@chakra-ui/react';

import React, { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { FaSearch } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { useParams } from 'react-router-dom';
import { useManajemenPengetahuanDaftarPesertaContext } from '../../../controller/admin/manajemen_pengetahuan/daftar-peserta';
import { useRole } from '../../../../hooks/useRole';
import Loader from '../../Loader';
import ModalSertifikat from '../ModalPengetahuan/ModalSertifikat';
import ModalTteSertifikat from '../ModalPengetahuan/ModalTteSertifikat';
import ButtonModalDeletePeserta from './ButtonModalDeletePeserta';
import Pusher from 'pusher-js';
import { BiCheckCircle } from 'react-icons/bi';


/**
 * Renders a table of participants in a knowledge-based assessment.
 *
 * @return {JSX.Element} The rendered table.
 * @author Bagas Prasetyadi
 */
const DaftarPesertaPengetahuan = ({
  isKlinikKhususServer,
  isKategoriKlinikServer,
  type,
}) => {
  const { id } = useParams() as { id: string };

  const {
    listData,
    isLoading,
    isLoadingDownload,
    search,
    page,
    perPage,
    jumlahData,
    isOpenModalTteSertifikat,
    accountTTESelected,
    isLoadingTTEPengetahuan,
    isLoadingGenerateExcel,
    generatePengetahuanId,
    isLoadingDownloadExcel,
    isGenerateJobRunning,
  } = useManajemenPengetahuanDaftarPesertaContext().state;
  const {
    fetchData,
    downloadFileAssessment,
    setPengetahuanDaftarPeserta,
    tteSertifikatPengetahuan,
    generateExcel,
    downloadExcel,
  } = useManajemenPengetahuanDaftarPesertaContext().dispatch;

  const { canMutate } = useRole();

  const generateBadgeColor = (status) => {
    switch (status) {
      case 'selesai':
        return 'green';
      case 'mengikuti':
        return 'yellow';
      default:
        return 'gray';
    }
  };

  const columns: any[] = [
    {
      name: 'NO.',
      selector: (row, index) => (page - 1) * perPage + index + 1,
      // (pagePengetahuanSaya - 1) * perPagePengetahuanSaya + (index + 1),
      width: '100px',
    },
    {
      name: 'NAMA',
      selector: (row) => row?.user.name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'NIP/NIK',
      selector: (row) => row?.user.nip ?? row?.user.nik,
      sortable: true,
      wrap: true,
    },
    {
      name: 'NILAI KUIS',
      selector: (row) => row?.nilai_quiz,
      sortable: true,
      wrap: true,
    },
    {
      name: 'FILE ASSIGNMENT',
      cell: (row, index) => {
        return (
          <>
            {row?.file_asesmen ? (
              <Button
                colorScheme="blue"
                leftIcon={<Icon as={IoDocumentTextOutline} />}
                isLoading={isLoadingDownload[index] || false}
                onClick={() => {
                  downloadFileAssessment(
                    id,
                    row?.userId,
                    row?.nama_file,
                    index
                  );
                }}
                h="35px"
                px={2}
              >
                Download Assignment
              </Button>
            ) : (
              '-'
            )}
          </>
        );
      },
      wrap: true,
    },
    {
      name: 'STATUS',
      selector: (row) => row?.status_pengetahuan,
      sortable: true,
      wrap: true,
      cell: (row) => {
        const badgeColor = generateBadgeColor(row?.status_pengetahuan);
        return (
          <Badge colorScheme={badgeColor}>{row?.status_pengetahuan}</Badge>
        );
      },
    },
    {
      name: 'AKSI',
      wrap: true,
      width: '200px',
      omit: !canMutate,
      cell: (row, index) => {
        return (
          <Flex gridGap="2" flexDirection="column" my="2">
            <>
              {type === 'synchronized' &&
                (row?.status_tte === 'DONE' ? (
                  <>
                    <ModalSertifikat
                      id={row.pengetahuan_id}
                      urlSertifikat={row.path_certificate_url}
                      name={row.user.name}
                    />
                    <Button
                      colorScheme="gray"
                      onClick={() => {
                        setPengetahuanDaftarPeserta(
                          'isOpenModalTteSertifikat',
                          true
                        );
                        setPengetahuanDaftarPeserta(
                          'ttePengetahuanId',
                          row.pengetahuan_id
                        );
                        setPengetahuanDaftarPeserta('tteUserId', row.user_id);
                        setPengetahuanDaftarPeserta('isTteUlang', true);
                      }}
                      isDisabled={
                        !isKlinikKhususServer ||
                        (isKlinikKhususServer &&
                          isKategoriKlinikServer === 'SUB')
                      }
                    >
                      Regenerate Sertifikat
                    </Button>
                  </>
                ) : (
                  <Button
                    colorScheme="green"
                    onClick={() => {
                      setPengetahuanDaftarPeserta(
                        'isOpenModalTteSertifikat',
                        true
                      );
                      setPengetahuanDaftarPeserta(
                        'ttePengetahuanId',
                        row.pengetahuan_id
                      );
                      setPengetahuanDaftarPeserta('tteUserId', row.user_id);
                      setPengetahuanDaftarPeserta('isTteUlang', false);
                    }}
                    isDisabled={
                      !isKlinikKhususServer ||
                      (isKlinikKhususServer && isKategoriKlinikServer === 'SUB')
                    }
                  >
                    TTE Sertifikat
                  </Button>
                ))}
              <ButtonModalDeletePeserta
                pesertaId={row.id}
                pesertaName={row.user.name}
                pengetahuanId={id}
              />
            </>
          </Flex>
        );
      },
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#F2FFFB',
        fontWeight: '900',
        fontSize: '13px',
      },
    },
  };

  const pusherApiKey = process.env.REACT_APP_PUSHER_API_KEY || '';
  const pusherCluster = process.env.REACT_APP_PUSHER_CLUSTER || '';

  useEffect(() => {
    const pusher = new Pusher(pusherApiKey, {
      cluster: pusherCluster,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
    });
    const channel = pusher.subscribe('job-channel');

    channel.bind('generate.excel.pengetahuan_peserta', function (data) {
      if (data.pengetahuan_id === Number(id)) {
        setPengetahuanDaftarPeserta('generatePengetahuanId', (prevState) => [
          ...prevState,
          data.pengetahuan_id,
        ]);
        setPengetahuanDaftarPeserta('isGenerateJobRunning', false);
      }
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pusherApiKey, pusherCluster]);

  useEffect(() => {
    fetchData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, page, perPage]);

  const handlePerRowsChangePengajuan = async (newPerPage, page) => {
    setPengetahuanDaftarPeserta('page', page);
    setPengetahuanDaftarPeserta('perPage', newPerPage);
  };

  const handlePageChangePengajuan = (page) => {
    setPengetahuanDaftarPeserta('page', page);
  };

  const exportToolbar: any = canMutate ? (
    <Flex flexDirection="column">
      <Flex>
        <Button
          colorScheme="blue"
          leftIcon={<Icon as={FiDownload} />}
          ml={3}
          onClick={() => generateExcel(id)}
          isLoading={isLoadingGenerateExcel}
          isDisabled={isLoadingGenerateExcel}
        >
          Generate
        </Button>
        <Button
          colorScheme="green"
          leftIcon={<Icon as={FiDownload} />}
          ml={3}
          onClick={() => downloadExcel(id)}
          isLoading={isLoadingDownloadExcel}
          isDisabled={isGenerateJobRunning || isLoadingDownloadExcel}
        >
          Download
        </Button>
      </Flex>
      {generatePengetahuanId && (
        <Text color="green.400" fontSize="xs" display="flex" ml={3} mt={2}>
          <BiCheckCircle size={16} /> Generate Telah Selesai
        </Text>
      )}
    </Flex>
  ) : null;

  return (
    <>
      <Box bg="white" p={4}>
        <Flex
          justifyContent="flex-end"
          alignItems="start"
          flexDirection={{ base: 'column', md: 'row' }}
          mb={4}
        >
          <InputGroup w="250px" mt={{ base: 4, md: 0 }}>
            <InputLeftElement pointerEvents="none">
              <FaSearch />
            </InputLeftElement>
            <Input
              type="text"
              placeholder="Cari Disini..."
              onChange={(e) => {
                setPengetahuanDaftarPeserta('search', e.target.value);
                setPengetahuanDaftarPeserta('page', 1);
              }}
              _focus={{
                ring: '1',
                ringColor: 'green.700',
                borderColor: 'green.700',
              }}
            />
          </InputGroup>
          {exportToolbar}
        </Flex>
        <DataTable
          data={listData}
          columns={columns}
          customStyles={customStyles}
          pagination
          paginationServer
          onChangeRowsPerPage={handlePerRowsChangePengajuan}
          onChangePage={handlePageChangePengajuan}
          paginationTotalRows={listData.length > 0 ? jumlahData : 0}
          progressPending={isLoading}
          progressComponent={<Loader />}
          noDataComponent="Tidak ada data"
        />
      </Box>

      {/* modal */}
      <ModalTteSertifikat
        isOpen={isOpenModalTteSertifikat}
        onClose={() =>
          setPengetahuanDaftarPeserta('isOpenModalTteSertifikat', false)
        }
        onSubmit={() => tteSertifikatPengetahuan()}
        selectedAccount={accountTTESelected}
        onAccountChange={(option) =>
          setPengetahuanDaftarPeserta('accountTTESelected', option)
        }
        isLoading={isLoadingTTEPengetahuan}
      />
    </>
  );
};

export default DaftarPesertaPengetahuan;
